module.exports = __webpack_public_path__ + "static/media/publicsonar_infrastructure_hover.f208e312.svg";